export enum WoundEmergence {
  FACILITY = 'FACILITY',
  EXTHOSPITAL = 'EXTHOSPITAL',
  EXTHOME = 'EXTHOME',
  NOTCOMPREHENSIBLE = 'NOTCOMPREHENSIBLE',
}
